import { brand } from '@parsina/framework/ui/lib/brand';

import logo from 'url:../assets/logo.png';
import logoWhite from 'url:../assets/logo-white.png';
import proxiaLogo from 'url:../../brand-packs/proxia/logo.png';
import proxiaLogoWhite from 'url:../../brand-packs/proxia/logo-white.png';

// ─────────────────────────────────────────────────────────────────────────────
// The panel's own images, chosen by the brand's `assetPack`
// (docs/rebranding/CONTRACT.md §2) — the same shape as the clinic panel's.
//
//   logo        the colour mark — the session-error card
//   logoWhite   the white mark on the brand gradient — the boot card, the sidebar
//
// No pack: today's bundled Parsina images, exactly as before. A pack this build
// carries: that pack's images, bundled from brand-packs/<pack>/ — the same
// folder the image bakes and docker-entrypoint.sh serves at /brand/ for the
// favicon, home-screen icons and manifest. Chosen when drawn, not when this
// module loads: the brand is configured at boot, after these imports.
// ─────────────────────────────────────────────────────────────────────────────

const PARSINA = Object.freeze({ logo, logoWhite });

const PACKS = Object.freeze({
  proxia: Object.freeze({ logo: proxiaLogo, logoWhite: proxiaLogoWhite }),
});

/** The pack drawn: the brand's `assetPack` when this build carries it, else 'parsina'. */
export function assetPackInUse() {
  const id = brand().assetPack;
  return id && Object.prototype.hasOwnProperty.call(PACKS, id) ? id : 'parsina';
}

/**
 * The URL of one of the panel's images under the brand in force.
 *
 * @param {'logo'|'logoWhite'} name
 */
export function brandAsset(name) {
  const id = assetPackInUse();
  return (id === 'parsina' ? PARSINA : PACKS[id])[name] ?? null;
}
